import React from 'react'

const ICON_MAP = {
  book: '/brand-icons/amoxtli-book.svg',
  stamp: '/brand-icons/amoxtli-stamp.svg',
  folio: '/brand-icons/amoxtli-folio.svg',
  satSeal: '/brand-icons/amoxtli-sat-seal.svg',
}

export function AmoxtliIcon({
  variant = 'book',
  className = 'h-5 w-5',
  alt,
}) {
  const src = ICON_MAP[variant] || ICON_MAP.book
  const label = alt || `Icono ${variant} de Amoxtli`

  return <img src={src} alt={label} className={className} loading="lazy" />
}

export default AmoxtliIcon
